import styled from 'styled-components';
import { Body2, WebLink2 } from 'ui/theme';

export const Ul = styled.ul`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  list-style-type: disc;
`;

const Description = styled(Body2)`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const HipaaDescription = () => (
  <>
    <Description>
      HIPAA customers process ePHI through Iterable and there are additional obligations on how we
      store and process this data including:
    </Description>
    <Ul>
      <li>
        A signed BAA (Business Associate Agreement) in Salesforce under Account: Customer Info
      </li>
      <li>Customers are required to use either Amazon SES or Mailgun as their ESP</li>
      <li>ePHI can’t be included in push notifications (In-app is OK)</li>
      <li>JWT enabled API keys are required for Mobile</li>
      <li>
        Customers will need to execute a separate BAA with third party integrations not covered
      </li>
    </Ul>
    <Description>
      If you have any questions on this please email&nbsp;
      <WebLink2 href="mailto:compliance@iterable.com">compliance@iterable.com.</WebLink2>
    </Description>
  </>
);
